const ERROR_KEYS: Record<string, string> = {
  social_analytics_media_not_found: 'analytics.errors.mediaNotFound',
  social_analytics_invalid_timezone: 'analytics.errors.invalidTimezone',
  social_analytics_invalid_media_type: 'analytics.errors.invalidMediaType',
  social_analytics_invalid_period: 'analytics.errors.invalidPeriod',
};

type ErrorWithGraphQLErrors = { graphQLErrors?: ReadonlyArray<{ message?: string }> } | null | undefined;

/** Copy key for a known backend error code, or null — raw backend text is never shown. */
export function analyticsErrorKey(error: ErrorWithGraphQLErrors): string | null {
  const code = error?.graphQLErrors?.map((item) => item.message).find((message) => typeof message === 'string' && Object.prototype.hasOwnProperty.call(ERROR_KEYS, message));
  return code ? ERROR_KEYS[code] : null;
}
